module.exports = __webpack_public_path__ + "img/header-wallet-bg.2ba02995.png";